'use client';

import { FC } from 'react';
import { AnonymousUserDisplay } from './components/AnonymousUserDisplay';
import { GuestUserDisplay } from './components/GuestUserDisplay';
import { VerifiedUserDisplay } from './components/VerifiedUserDisplay';
import { useGetUserStatus } from '@/userStatus/hooks';

export const UserStatusDisplay: FC = () => {
  const { status } = useGetUserStatus();

  return (
    <div className="flex flex-grow cursor-pointer items-center md:flex-col lg:flex-row">
      {status === 'VERIFIED' && <VerifiedUserDisplay />}
      {status === 'ANONYMOUS' && <AnonymousUserDisplay />}
      {status === 'GUEST' && <GuestUserDisplay />}
    </div>
  );
};
